import React from "react";
import "../assets/styles/skils.css";
const Skils = ({ current }) => {
  const skils = [
    { name: "html", percentage: 95 },
    { name: "css", percentage: 80 },
    { name: "bootstrap", percentage: 90 },
    { name: "javascript", percentage: 80 },
    { name: "React", percentage: 85 },
    { name: "material UI", percentage: 70 },
    { name: "Ant design", percentage: 60 },
    { name: "Redux", percentage: 70 },
    { name: "Next js", percentage: 50 },
    { name: "stripe payment", percentage: 75 },
    { name: "node js", percentage: 50 },
    { name: "express js", percentage: 65 },
    { name: "mongoDb", percentage: 40 },
    { name: "mongoose ", percentage: 30 },
  ];
  return (
    <div className="my_skils_container">
      {/* <div className="mey_skils_header">
        <p>My expert areas</p>
      </div> */}
      <div
        className={
          current ? " my_skils_item_content " : "my_skils_item_content"
        }
      >
        {skils.map((item, index) => {
          return (
            <div className="my_skils_item_container" key={index}>
              <div className="skisl_logo">
                <p className={`skils_logo${item.percentage}`}>{item.name}</p>
              </div>
              {/* <p className="my_skils_item_item_name">
                {item.name} {`(${item.percentage}%)`}
              </p> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Skils;
